"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var reducers_1 = require("./reducers");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var EMPTY_OBJ = {};
var EMTPY_ARRAY = [];
exports.getAllFetched = function (state) { return get_1.default(state, reducers_1.ROOT_KEY + ".fetched", EMPTY_OBJ); };
exports.getAllFetching = function (state) { return get_1.default(state, reducers_1.ROOT_KEY + ".fetching", EMPTY_OBJ); };
exports.getAllFetchingErrors = function (state) { return get_1.default(state, reducers_1.ROOT_KEY + ".fetchingErrors", EMTPY_ARRAY); };
exports.getFetched = function (state, type) {
    return get_1.default(state, reducers_1.ROOT_KEY + ".fetched." + type, false);
};
exports.getFetching = function (state, type) {
    return get_1.default(state, reducers_1.ROOT_KEY + ".fetching." + type, false);
};
exports.getFetchingError = function (state, type) {
    return get_1.default(state, reducers_1.ROOT_KEY + ".fetchingErrors", EMTPY_ARRAY)
        .find(function (error) { return error.error === type; }) || false;
};
//# sourceMappingURL=selectors.js.map